module.exports = __webpack_public_path__ + "static/img/weather52.db749b7a.png";